import { LinkItem } from '@occc/ui-design-system';
import { routeCreator } from '@occc-app/routes/ProductGroup/utils';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

export const breadcrumbLinks: LinkItem[] = [
  { to: programManagementRouteCreator.base(), label: 'Program Management' },
  { key: routeCreator.list(), label: 'Product Groups' },
];
